import { fetch, fetchPreview } from "../index";
import { contentItem } from "../queries/contentItem";
import { contentPackage } from "../queries/contentPackage";
import { photoGallery } from "../queries/photoGallery";
import { GRAPHQL_URL } from "../constants";
import { isValidContentId } from "../../../utils/dataTransform/ContentItem/library";
import { HTTP_NOT_FOUND } from "../../../constants/http";
import { HttpError } from "../../../utils/errors/http";
import { getFeedCookie } from "../../../utils/cookies/library";

const getContentStatus = (preview) => {
    let contentStatus = "";
    if (preview === "polopoly") {
        contentStatus = "preview";
    } else if (preview === "nine") {
        const nine_gtoken = getFeedCookie("nine_gtoken");
        contentStatus = `preview;aggToken=${
            nine_gtoken?.value
        };cacheBust=${new Date().getTime()}`;
    }
    return contentStatus;
};

/**
 * Fetch ContentItem data with specified query from GraphQL
 *
 * @param {string} contentId the contentId of the story
 * @param {string} preview type of preview: "nine", "polopoly", "" (none)
 * @param {function} queryFunction the query function to use
 * @param {any[]} queryArgs additional arguments to pass to the query function
 * @return {Promise<void>} the result of the query
 */
const fetchData = async (contentId, preview, queryFunction, ...queryArgs) => {
    if (!isValidContentId(contentId)) {
        throw new HttpError(HTTP_NOT_FOUND, "Not Found");
    }
    const fetchContent = preview ? fetchPreview : fetch;
    const contentStatus = getContentStatus(preview);

    return await fetchContent(GRAPHQL_URL, {
        query: queryFunction(contentId, contentStatus, ...queryArgs),
    });
};

/**
 * Fetch ContentItem data for non-content package and non-photogallery items from GraphQL
 *
 * @param {string} contentId the contentId of the story
 * @param {string} preview type of preview: "nine", "polopoly", "" (none)
 * @return {function} fetchData function
 */
export async function fetchContentItem(contentId, preview = "") {
    return fetchData(contentId, preview, contentItem);
}

/**
 * Fetch PhotoGallery contentItem data from GraphQL
 *
 * @param {string} contentId the contentId of the story
 * @param {string} preview type of preview: "nine", "polopoly", "" (none)
 * @param {string} aspectRatio
 * @return {function} fetchData function
 */
export async function fetchPhotoGallery(contentId, preview = "", aspectRatio) {
    return fetchData(contentId, preview, photoGallery, aspectRatio);
}

/**
 * Fetch Content Package contentItem data from GraphQL
 *
 * @param {string} contentId the contentId of the story
 * @param {string} preview type of preview: "nine", "polopoly", "" (none)
 * @return {function} fetchData function
 */
export async function fetchContentPackage(contentId, preview = "") {
    return fetchData(contentId, preview, contentPackage);
}
